var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.764 23.24L18.7415 23.24C20.2061 23.24 21.4044 22.0012 21.4044 20.487V2.75303C21.4044 1.23887 20.2061 -1.28039e-07 18.7415 0L2.76399 1.3968e-06C1.29939 1.52484e-06 0.101072 1.23887 0.101074 2.75304V20.487C0.101074 22.0012 1.29939 23.24 2.764 23.24ZM4.09546 12.8704L17.4101 12.8704V15.6235L4.09546 15.6235L4.09546 12.8704ZM4.09546 17.2982L17.4101 17.2982V20.0513L4.09546 20.0513L4.09546 17.2982ZM11.9125 7.63985H14.6215V4.89748H11.9125V2.15511H9.20347V4.89748H6.49443V7.63985H9.20347V10.3822H11.9125V7.63985Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipe);
export default __webpack_public_path__ + "static/media/recipe.9940f5615cc26382948165e725fb3e3a.svg";
export { ForwardRef as ReactComponent };